import type { IconSetDefinitions } from '@hotjar/hotsauce/build/components/Icon/icons';

export const transformOsNameToIcon = (os: string): keyof IconSetDefinitions => {
  const osLowerCase = os.toLowerCase();
  if (osLowerCase.indexOf('android') > -1) {
    return 'android';
  }
  if (osLowerCase.indexOf('blackberry') > -1) {
    return 'blackberry';
  }
  if (osLowerCase.indexOf('chrome') > -1) {
    return 'chrome';
  }
  if (
    osLowerCase.indexOf('ios') > -1 ||
    osLowerCase.indexOf('os x') > -1 ||
    osLowerCase.indexOf('mac') > -1
  ) {
    return 'apple';
  }
  if (osLowerCase.indexOf('linux') > -1) {
    return 'linux';
  }
  if (osLowerCase.indexOf('ubuntu') > -1) {
    return 'ubuntu';
  }
  if (osLowerCase.indexOf('windows') > -1) {
    return 'windows';
  }
  return 'unknown';
};
